import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LmsApi } from '@services/_api/lms-api';
import { LearnershipSelectorService } from './../../../_services/learnership-selector.service';

@Component({
  selector: 'app-learnership-selector',
  templateUrl: './learnership-selector.component.html',
  styleUrls: ['./learnership-selector.component.css'],
})
export class LearnershipSelectorComponent {
  constructor(
    private dialogRef: MatDialogRef<LearnershipSelectorComponent>,
    @Inject(MAT_DIALOG_DATA)
    public initialLearnerships: LmsApi.GetCurrentStudentsLearnershipsViewModel[],
    public learnershipSelectorService: LearnershipSelectorService
  ) {
    // auto select most recent learnership on the first time the dialog is opened
    if (!this.learnershipSelectorService.studentLearnershipSelected) {
      this.learnershipSelectorService.setMostRecentStudentLearnership();
      this.dialogRef.close(learnershipSelectorService.currentStudentLearnership);
    }
  }

  public learnershipSelected(
    learnership: LmsApi.GetCurrentStudentsLearnershipsViewModel
  ) {
    this.dialogRef.close(learnership);
  }
}
